<div class="ed-header">
  <div class="ed-icon">
    <mat-icon>person_outline</mat-icon>
  </div>
  <div>
    <h2 mat-dialog-title class="ed-title">Eliminar empleado</h2>
    <p class="ed-sub">Esta acción no se puede deshacer</p>
  </div>
  <button mat-icon-button class="ed-close" [mat-dialog-close]="null" matTooltip="Cerrar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content class="ed-content">
  <p *ngIf="!error" class="ed-msg">
    ¿Seguro que quieres eliminar este empleado?
  </p>
  <div *ngIf="error" class="ed-feedback">
    <mat-icon>check_circle</mat-icon>
    <span>Empleado eliminado correctamente</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="ed-actions">
  <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
  <button *ngIf="!error" mat-flat-button class="ed-btn-delete" (click)="delete()">
    <mat-icon>delete</mat-icon> Eliminar
  </button>
</mat-dialog-actions>
